module.exports = __webpack_public_path__ + "static/fdic-desktop.d478dd6c.svg";